import { Link } from 'react-router-dom';
import { coverageItems } from '../../data/coverage';
import { useInView } from '../../hooks/useInView';
import styles from './Coverage.module.css';

/**
 * Coverage — 잡지 페이지가 쌓이는 듯한 sticky stack 섹션.
 * 각 배너는 `position: sticky`로 스크롤을 따라 올라오며, 다음 배너가 위로 덮어 쌓입니다.
 * 각 배너는 고유한 --i 인덱스를 받아 stick top 위치가 누적 offset 됩니다 →
 * 끝에서 보면 여러 배너의 윗단이 카드처럼 겹쳐 보이는 효과.
 */
export function Coverage() {
  const { ref, inView } = useInView();

  return (
    <section className={styles.section} id="coverage">
      <div className="wrap">
        <div ref={ref} className={`${styles.header} reveal ${inView ? 'visible' : ''}`}>
          <h2 className={styles.headline}>
            의료인이라면 언젠가
            <br />
            마주치는 상황들
          </h2>
          <p className={styles.sub}>혼자 감당하려다 더 커지기 전에, 전문가와 먼저 확인하세요.</p>
        </div>

        <div className={styles.stack} style={{ '--total': coverageItems.length }}>
          {coverageItems.map((item, i) => (
            <article
              key={item.n}
              className={styles.banner}
              style={{ '--i': i }}
              aria-label={`${item.n} ${item.name}`}
            >
              <img src={item.img} alt={item.name} className={styles.bannerImg} />
              <div className={styles.bannerOverlay} />

              <div className={styles.bannerBody}>
                <div className={styles.bannerMeta}>
                  <span className={styles.num}>{item.n}</span>
                  <span className={styles.tag}>{item.name}</span>
                </div>
                <h3 className={styles.pain}>{item.pain}</h3>
                <p className={styles.desc}>{item.desc}</p>
                {item.slug && (
                  <Link to={`/coverage/${item.slug}`} className={styles.detailLink}>
                    자세히 보기
                    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                      <path
                        d="M3 8h10M9 4l4 4-4 4"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Link>
                )}
              </div>

              {/* 쌓이는 느낌을 강조하는 상단 인덱스 탭 */}
              <div className={styles.bannerIndex} aria-hidden="true">
                <span className={styles.bannerIndexNum}>{item.n}</span>
                <span className={styles.bannerIndexOf}>/ {coverageItems.length}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
